//#region IMPORT
import React from 'react';
import {
  ChevronRight as ChevronRightIcon,
  NotificationImportantOutlined as NotificationImportantOutlinedIcon,
  WarningAmber as WarningAmberIcon,
} from '@mui/icons-material';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
//#endregion

function M_RNM_BASIC_01(props) {
  const { navigate } = useAppNavigate();

  return (
    <div className="min-h-full bg-[#f6f6f8]">
      <div className="mx-auto w-full max-w-2xl flex-1 overflow-y-auto px-5 py-8">
        <div className="mb-8">
          <h2 className="mb-2 text-2xl leading-tight font-bold">
            어떤 위험을
            <br />
            제보할까요?
          </h2>
          <p className="text-sm text-slate-500">
            더 안전한 우리 동네를 위해 제보해주세요.
          </p>
        </div>
        <div className="space-y-4">
          {/* Card 1: Risk Factor */}
          <div
            role="button"
            tabIndex={0}
            className="group relative cursor-pointer overflow-hidden rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-all hover:shadow-md active:scale-[0.98]"
            onClick={() => navigate('/M_RNM/write/risk')}
          >
            <div className="mb-4 flex items-start justify-between">
              <div className="rounded-xl bg-[#f97316]/10 p-3">
                <WarningAmberIcon className="!text-3xl text-[#f97316]" />
              </div>
              <ChevronRightIcon className="text-slate-300 transition-colors group-hover:text-slate-500" />
            </div>
            <div>
              <h3 className="mb-1 text-xl font-bold">위험요인 제보하기</h3>
              <p className="text-sm leading-relaxed text-slate-500">
                도로 파손, 시설 결함 등
                <br />
                일상 속 위험 요소를 제보해주세요.
              </p>
            </div>
            <div className="pointer-events-none absolute -right-4 -bottom-2 opacity-5 transition-opacity group-hover:opacity-10">
              <WarningAmberIcon className="!text-[96px]" />
            </div>
          </div>
          {/* Card 2: Near Miss */}
          <div
            role="button"
            tabIndex={0}
            className="group relative cursor-pointer overflow-hidden rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-all hover:shadow-md active:scale-[0.98]"
            onClick={() => navigate('/M_RNM/write/nearMiss')}
          >
            <div className="mb-4 flex items-start justify-between">
              <div className="rounded-xl bg-[#22c55e]/10 p-3">
                <NotificationImportantOutlinedIcon className="!text-3xl text-[#22c55e]" />
              </div>
              <ChevronRightIcon className="text-slate-300 transition-colors group-hover:text-slate-500" />
            </div>
            <div>
              <h3 className="mb-1 text-xl font-bold">아차사고 상황 제보</h3>
              <p className="text-sm leading-relaxed text-slate-500">
                아차 사고(Near Miss) 사례를
                <br />
                공유하여 더 큰 사고를 예방해요.
              </p>
            </div>
            <div className="pointer-events-none absolute -right-4 -bottom-2 opacity-5 transition-opacity group-hover:opacity-10">
              <NotificationImportantOutlinedIcon className="!text-[96px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default M_RNM_BASIC_01;
